import { Entity } from '../entity';

/** Tenant exception over a generated statewide calendar. Extra = honor this day. Shadow = do not honor a base day on this date+scope. */
export enum PublicHolidayKind {
    Extra = 'extra',
    Shadow = 'shadow',
}

/** Board/display origin. Library rows are generated; extra/shadow are tenant writes. */
export enum PublicHolidayOrigin {
    Library = 'library',
    Extra = 'extra',
    Shadow = 'shadow',
}

export interface PublicHoliday extends Entity {
    date: Date;
    year: number;
    states: Entity[];
    zones: Entity[];
    /** Missing on legacy rows: treat as extra. */
    kind?: PublicHolidayKind;
    /** Projection-only. Never persisted. */
    origin?: PublicHolidayOrigin;
}
